// extracted by mini-css-extract-plugin
var _1 = "tjs-feature-info-download__btn tjs-_buttons__btn-primary";
var _2 = "tjs-feature-info-download__download";
var _3 = "tjs-feature-info-download__dropdown__button tjs-_buttons__btn--small";
var _4 = "tjs-feature-info-download__dropdown__list";
var _5 = "tjs-feature-info-download__dropdown__button tjs-_buttons__btn--small";
var _6 = "tjs-feature-info-download__dropdown__list";
var _7 = "tjs-feature-info-download__icon--download";
var _8 = "tjs-feature-info-download__icon--download";
export { _1 as "btn", _2 as "download", _3 as "dropdownButton", _4 as "dropdownList", _5 as "dropdown__button", _6 as "dropdown__list", _7 as "icon--download", _8 as "iconDownload" }
export default { "btn": _1, "download": _2, "dropdownButton": _3, "dropdownList": _4, "dropdown__button": _5, "dropdown__list": _6, "icon--download": _7, "iconDownload": _8 }
